import React from "react";
import { connect } from "react-redux";
import { FiCornerUpLeft, FiEdit2, FiTrash2 } from "react-icons/fi";
import { BsChatLeftText } from "react-icons/bs";

function Table({ columns = [], list = [], onFeedback }) {

  const formatValue = (item, col, index) => {
    return item[col.key] || "-";
  };

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-left border-collapse">

        {/* HEADER */}
        <thead className="bg-indigo-100 text-base border-b border-gray-300">
          <tr>
            {columns.map((col, i) => (
              <th key={i} className="md:px-6 px-3 py-4 whitespace-nowrap">
                {col.label}
              </th>
            ))}
            <th className="md:px-6 px-3 py-4 text-center whitespace-nowrap">Action</th>
          </tr>
        </thead>

        {/* BODY */}
        <tbody className="divide-y divide-gray-300">
          {list.length > 0 ? (
            list.map((item, index) => (
              <tr
                key={item._id || index}
                className="transition-colors text-sm"
              >
                {columns.map((col, i) => (
                  <td key={i} className="md:px-6 px-3 py-3 whitespace-nowrap">
                    {formatValue(item, col, index)}
                  </td>
                ))}

                {/* ACTION */}
                <td className="md:px-6 px-3 py-3">
                  <div className="flex justify-center gap-3 whitespace-nowrap">
                    <button onClick={() => onFeedback && onFeedback(item)}
                      className="p-2 insightactive bg-indigo-100 rounded-md transition"><BsChatLeftText size={18} /></button>
                  </div>
                </td>

              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan={columns.length + 1}
                className="text-center py-6 text-gray-500"
              >
                No Data Found
              </td>
            </tr>
          )}
        </tbody>

      </table>
    </div >
  );
}

const mapStateToProps = (state) => ({
  loggingIn: state.authentication?.loggingIn,
  dashboard: state.dashboard,
});

export default connect(mapStateToProps)(Table);